<template>
  <Breadcrumbs
    title="System Parameters"
    :breadcrumbs="[
      { label: 'System Config', path: '' },
      { label: 'System Parameters', path: '/system-parameters' },
    ]"
  />

  <div class="container-fluid">
    <div class="row project-cards">
      <systemParametersManagementForm />
    </div>
  </div>
</template>

<script>
import systemParametersManagementForm
  from "@/pages/system_config/system_parameters/systemParametersManagementForm.vue";

export default {
  components: {
    systemParametersManagementForm
  }
};
</script>